<template>
    <div>
        <modal-share-house class="landlord-auth-modal" :display="modalStatus.landlordAuthModal" @modalStatus="closeModal" >
            <div class="landlord-auth-modal-wrap">
                <div class="content">
                   <div class="list">
                       <div class="title">
                           這個標章是什麼意思？
                       </div>
                       <div class="description">
                           此物件有提供房東委託證明
                       </div>
                   </div>
                   <div class="list">
                       <div class="title">
                           何時可以看到委託證明？
                       </div>
                       <div class="description">
                           在您預定後，簽約之前即可瀏覽房東委託證明
                       </div>
                   </div>
                </div>
            </div>
        </modal-share-house>
    </div>
</template>
<script>
import ModalShareHouse from '@/components/widge/ModalShareHouse.vue';
import { mapGetters } from 'vuex'

export default {
    methods: {
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'landlordAuthModal'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        ModalShareHouse,
    }
}
</script>
<style lang="scss" scoped>
    #modal.landlord-auth-modal{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 458px;
            height: 306px;
            padding: 0 !important;
            display: flex;
            align-items: center;
            justify-content: center;
            .detail{
                .landlord-auth-modal-wrap{
                    padding: 0 32px 0 32px;
                    .content{
                        width: 100%;
                        height: 100%;
                        padding-top: 38px;
                        .list{
                            margin-bottom: 48px;
                            .title{
                                position: relative;
                                font-size: 20px;
                                font-weight: 600;
                                margin-bottom: 10px;
                                &::before{
                                    content: '';
                                    position: absolute;
                                    height: 19px;
                                    width: 6px;
                                    background: #01bdfe;
                                    border-radius: 4px;
                                    left: -16px;
                                    top: 3px;
                                }
                            }
                            .description{
                                font-size: 16px;
                                color: #909090;
                            }
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 992px) {
        #modal.landlord-auth-modal{
            .modal-content{
                .detail{
                    .landlord-auth-modal-wrap{
                        width: 220px;
                        padding: 0 32px 0 32px;
                        .content{
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/landlordAuth.vue